import { render, staticRenderFns } from "./team-session.vue?vue&type=template&id=4295652c&"
import script from "./team-session.vue?vue&type=script&lang=js&"
export * from "./team-session.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Vuejs-Project\\subsappadminOrg\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4295652c')) {
      api.createRecord('4295652c', component.options)
    } else {
      api.reload('4295652c', component.options)
    }
    module.hot.accept("./team-session.vue?vue&type=template&id=4295652c&", function () {
      api.rerender('4295652c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/club-teams/team-session.vue"
export default component.exports